<template>
  <div class="date-bar">
    <Button icon class="prev" :disabled="isMin" @click="prev"><ArrowLightIcon /></Button>
    <CalendarPopover
      todayButton
      isSP
      :date="date"
      :holidayList="holidays"
      :businessDay="businessDay"
      :popperOptions="{ modifiers: { flip: { enabled: false }, preventOverflow: { enabled: false } } }"
      :reserveCalendar="reserveCalendar"
      :busy="busy"
      v-on="listeners"
    >
      <div class="date">{{ formatDate(date, 'M月D日 (dd)') }}<CalendarIcon /></div>
    </CalendarPopover>
    <Button icon class="next" :disabled="isMax" @click="next"><ArrowLightIcon /></Button>
  </div>
</template>

<script>
import { addDays, isAfter, isBefore } from 'date-fns'
import { formatDate, toHourClock } from '@/utils/date'
import CalendarPopover from '@/components/molecules/CalendarPopover'
import Button from '@/components/atoms/Button'
import ArrowLightIcon from '@/components/icons/arrowLight'
import CalendarIcon from '@/components/icons/CalendarIcon'

/**
 * 日付選択
 */
export default {
  name: 'DateBar',
  components: {
    CalendarPopover,
    Button,
    ArrowLightIcon,
    CalendarIcon,
  },
  props: {
    /** 日付 YYYY-MM-DD */
    date: String,
    /** 予約日付 YYYY-MM-DD */
    reserveDate: String,
    /** 祝日一覧 */
    holidays: Array,
    /** 定休日一覧 */
    businessDay: { type: Object, default: () => {} },
    /** 予約数一覧 */
    reserveCalendar: { type: Object, default: () => ({}) },
    /** ローディング */
    busy: { type: Boolean, default: false },
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
        change: this.changeDate,
        setDate: this.setDate,
        beforeShow: this.beforeShow,
      }
    },
    today() {
      return toHourClock(new Date()).date
    },
    minDate() {
      return this.reserveDate ? this.today : '2000-01-01'
    },
    isMin() {
      return !isAfter(this.date, this.minDate)
    },
    isMax() {
      return !isBefore(this.date, '2099-12-31')
    },
  },
  methods: {
    formatDate,
    prev() {
      this.changeDate(formatDate(addDays(this.date, -1), 'YYYY-MM-DD'))
    },
    next() {
      this.changeDate(formatDate(addDays(this.date, 1), 'YYYY-MM-DD'))
    },
    changeDate(date) {
      this.$emit('changeDate', date)
    },
    setDate(date) {
      this.$emit('setDate', date)
    },
    beforeShow() {
      this.$emit('beforeShow')
    },
  },
}
</script>

<style lang="postcss" scoped>
.date-bar {
  align-items: center;
  background: var(--white);
  border-bottom: 1px solid var(--light-gray);
  box-sizing: border-box;
  display: flex;
  fill: var(--white);
  flex-shrink: 0;
  font-weight: bold;
  justify-content: space-between;
  padding: 0 16px;
  position: relative;
  width: 100%;

  .date {
    align-items: center;
    cursor: pointer;
    display: grid;
    fill: var(--brand-color);
    font-size: 21px;
    grid-auto-flow: column;
    grid-gap: 8px;
    height: 55px;
    justify-content: center;
  }

  > .prev {
    transform: rotate(90deg);
  }

  > .next {
    transform: rotate(-90deg);
  }
}
</style>
